import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataModel } from 'qp-storefront';
import { ServiceResponse } from 'qp-ui-interface';
import { LocalStorageKeys } from '../../../LocalStorageKeys';
import { ConfigService } from '../../config/config.service';
import { LocalStorageService } from './../../local-storage/local-storage.service';
@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private configService: ConfigService, private http: HttpClient, private localStorage: LocalStorageService) {}
  public async fetchGuestToken(deviceId: string, deviceName: string): Promise<DataModel> {
    try {
      const response = await this.http
        .post<ServiceResponse<DataModel>>(`${this.configService.applicationConfig.guestFlatURL}/platform/access/token`, {
          deviceId,
          deviceName,
        })
        .toPromise();
      this.localStorage.setItem(LocalStorageKeys.XAUTH_TOKEN, response.data?.token);
      this.localStorage.setItem(LocalStorageKeys.XAUTH_TOKEN_EXP, (Math.floor(Date.now() / 1000) + response.data?.expires_in)?.toString());
      return response.data;
    } catch (_) {
      this.localStorage.removeItem(LocalStorageKeys.XAUTH_TOKEN);
      return null;
    }
  }
}
